var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescargar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9834 3.65696C11.7622 3.60995 11.5816 3.46292 11.4888 3.25222C10.4541 0.925793 8.06 -0.375111 5.66531 0.0956414C3.48406 0.522386 1.77406 2.38006 1.40938 4.71949C1.30125 5.40995 1.30938 6.10141 1.43125 6.77486C1.47125 6.99457 1.3825 7.23928 1.20063 7.41565C0.437187 8.15611 0 9.21097 0 10.3105C0 12.4669 1.64469 14.2222 3.66656 14.2222H11C13.7572 14.2222 16 11.8295 16 8.88791C16 6.35245 14.3106 4.15238 11.9828 3.65729L11.9834 3.65663V3.65696ZM10.0816 9.03561L8.27688 10.961C8.01875 11.2363 7.67969 11.375 7.34031 11.3764L7.33438 11.3777L7.32844 11.3764C6.98906 11.375 6.64969 11.2363 6.39188 10.961L4.58719 9.03561C4.32656 8.75756 4.32656 8.30814 4.58719 8.02976C4.84781 7.75137 5.26906 7.75171 5.53 8.02976L6.66813 9.24398V5.68766C6.66813 5.29426 6.96688 4.97653 7.33469 4.97653C7.7025 4.97653 8.00125 5.29459 8.00125 5.68766V9.24398L9.13938 8.02976C9.4 7.75171 9.82125 7.75171 10.0822 8.02976C10.3431 8.30781 10.3428 8.75722 10.0822 9.03561H10.0816Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargar);
export default __webpack_public_path__ + "static/media/descargar.608fce6ddf1e57a209e491777e9b3a95.svg";
export { ForwardRef as ReactComponent };